<template>
	<div class="row items flex-row">
		<div class="columns column12">
			<div class="gallery-wrapper flex-row">
				<div
					v-for="item in items"
					:key="item.ID"
					class="columns column4 filter-item"
					:class="{ active: filter === item.galleryCategorie?.ID || filter === 'showAll' }"
				>
					<gallery-item :item="item" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {});
});
</script>

<style lang="scss" scoped>
.gallery-wrapper {
	background: var(--primary-background-color);
	padding: 10px;

	.filter-item {
		margin: 15px 0;
	}
}
</style>
